// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from "react";
import VerticalAlignTopOutlinedSvg from "@ant-design/icons-svg/lib/asn/VerticalAlignTopOutlined";
import AntdIcon from "../components/AntdIcon";
const VerticalAlignTopOutlined = (props, ref)=>/*#__PURE__*/ React.createElement(AntdIcon, {
        ...props,
        ref: ref,
        icon: VerticalAlignTopOutlinedSvg
    });
if (process.env.NODE_ENV !== "production") {
    VerticalAlignTopOutlined.displayName = "VerticalAlignTopOutlined";
}
export default /*#__PURE__*/ React.forwardRef(VerticalAlignTopOutlined);
